/** Holds the live fhirclient instance outside Redux (non-serializable). */
let heldFhirClient: any | null = null;

export const holdFhirClient = (client: any | null): void => {
  heldFhirClient = client;
};

export const getHeldFhirClient = (): any | null => heldFhirClient;

export const releaseFhirClient = (): void => {
  heldFhirClient = null;
};
